import { createI18nText } from '@hilma/netina2all';

const purchaseAtonementText = createI18nText({
    he: {
        subHeader: <>במידה וברצונך לתרום מתנות לאביונים לעמותה שבחרת, אנא בחר סכום.<br />תרומה זו מוכרת לפי סעיף 46.</>,
        otherAmount: 'סכום אחר',
        notIntrested: 'לא מעוניין',
    },
    en: {
        subHeader: <>If you would like to donate Matanot L'evyonim (gifts to the poor) to the association you have chosen, please select a sum.<br />These donations are tax deductable according to section 46.</>,
        otherAmount: 'Other',
        notIntrested: 'Not intrested',
    }
});

export default purchaseAtonementText;